
import IconButtonBase from 'components/UI/IconButtonBase';
import ExitToAppIcon from 'public/assets/svgs/icons/exit-to-app.svg';

const ExitToAppIconButton = props => (
  <IconButtonBase {...props}>
    <ExitToAppIcon />
  </IconButtonBase>
);

export default ExitToAppIconButton;
